import { createRoute } from '@tanstack/react-router';
import { lazyPage } from '../common';
import { staffRoute } from './route';

const pages = () => import('./team-pages');
const manageTeamComp = lazyPage(pages, 'ManageTeamHost');
const manageTeamActionComp = lazyPage(pages, 'ManageTeamActionHost');

const manageTeamRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: '/$siteId/staff/manage-team',
  component: manageTeamComp,
  staticData: { title: 'Staff - Manage Team' },
});

const manageTeamActionRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: '/$siteId/staff/manage-team/$actionType',
  component: manageTeamActionComp,
  staticData: { title: 'Staff - Manage Team' },
});

/** Team sub-group of the staff family. */
export const teamLeaves = [manageTeamRoute, manageTeamActionRoute];
